
export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: () => (``),
    },
  },
  data () {
    return {
      videoId: null,
      videoPost: null,
    };
  },
  mounted () {
    this.$nextTick(() => {
      if (this.block.use_id) {
        this.videoId = this.block.red_tv_video_id;
      } else {
        this.getVideoPost();
      }
    });
  },
  methods: {
    async getVideoPost () {
      if (this.block.video) {
        const params = {
          fields: `id,acf`,
          posts: {
            per_page: 1,
            p: this.block.video.ID,
            post_type: `video`,
          },
        };

        const request = await this.$getPosts(`/posts`, params);
        if (request !== null) {
          this.videoPost = request[0];
          this.videoId = this.videoPost.acf.red_tv_id;
        }
      }
    },
  },
};
